<template>
  <div id="app">
    <v-app v-if="showLoading" class="loading">
      <v-progress-circular
        :size="80"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <span class="mt-5">در حال دریافت اطلاعات,لطفا منتظر بمانید...</span>
    </v-app>
    <v-app id="inspire" v-else>
      <v-expansion-panels class="my-5 px-2" elevation="13">
        <v-expansion-panel>
          <v-expansion-panel-header color="#005bdd21">
            <h6 class="text-right">جستجو</h6>
          </v-expansion-panel-header>
          <v-expansion-panel-content color="#005bdd21">
            <div class="row pa-md-8">
              <div
                v-for="header in headers"
                :key="header.text"
                class="col-md-3 mb-5"
                v-show="
                  header.value !== 'isActive' && header.value !== 'actions'
                "
              >
                <div
                  v-if="filters.hasOwnProperty(header.value)"
                  class="filter-items"
                >
                  <date-picker
                    v-model="date"
                    v-if="header.value == 'insertDate'"
                    :show="showDatepicker"
                    @close="closeDatePicker"
                  >
                    <template #icon></template>
                  </date-picker>
                  <v-text-field
                    v-model="date"
                    placeholder="تاریخ"
                    clearable
                    v-if="header.value == 'insertDate'"
                    @click="showDate"
                    class="text-right"
                    reverse
                  ></v-text-field>
                  <v-autocomplete
                    v-else
                    flat
                    hide-details
                    attach
                    dense
                    clearable
                    :items="columnValueList(header.value)"
                    v-model="filters[header.value]"
                    class="text-right"
                    :placeholder="header.text"
                  >
                  </v-autocomplete>
                </div>
              </div>
              <div class="col-md-3 mb-5">
                <button class="btn filter-btn" @click="filterList">
                  فیلتر کردن
                </button>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="filteredDesserts"
        item-key="name"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-toolbar-title>لیست مشتریان</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <!-- <router-link to="/product-management/products/add">
                <v-btn class="mb-2 indigo darken-4 white--text button">
                  آیتم جدید
                </v-btn>
              </router-link> -->
            </v-row>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5">
                  <v-icon color="amber darken-1" class="ml-2">info</v-icon>
                  <p class="ma-0">
                    آیا مطمینید میخواهید آیتم مورد نظر را حذف کنید؟
                  </p>
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#00932a"
                    class="green lighten-4"
                    outline
                    text
                    @click="deleteItemConfirm"
                    >تایید کردن</v-btn
                  >
                  <v-btn
                    color="#b90000"
                    class="red lighten-4 mr-2"
                    text
                    @click="closeDelete"
                    >لغو کردن</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogShow" max-width="500px">
              <v-card>
                <v-card-title class="text-h5">
                  <v-icon color="amber darken-1" class="ml-2">info</v-icon>
                  <p class="ma-0">آیا مطمئن هستید قصد تغییر وضعیت دارید؟</p>
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#00932a"
                    class="green lighten-4"
                    outline
                    text
                    @click="toggleActivation"
                    >تایید کردن</v-btn
                  >
                  <v-btn
                    color="#b90000"
                    class="red lighten-4 mr-2"
                    text
                    @click="dialogShow = false"
                    >لغو کردن</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogCard" max-width="500px">
              <v-card>
                <v-card-title>
                  <v-icon color="amber darken-1">mdi-hotel</v-icon>
                  <p class="ma-0">
                    عنوان : <span>{{ card.name }}</span>
                  </p> </v-card-title
                ><v-divider></v-divider>
                <v-card-text class="mt-5 card-info-content">
                  <div class="mt-3">
                    <v-icon class="font-weight-bold" color="amber darken-1"
                      >mdi-time</v-icon
                    >
                    <span class="ma-0"
                      >تاریخ : <span>{{ card.mobile }}</span></span
                    >
                  </div>
                  <div class="mt-3">
                    <v-icon class="font-weight-bold" color="amber darken-1"
                      >mdi-calendar</v-icon
                    >
                    <span class="ma-0"
                      >تاریح : <span>{{ card.insertDate }}</span></span
                    >
                  </div>
                  <div class="mt-3">
                    <v-icon class="font-weight-bold" color="amber darken-1"
                      >mdi-layer</v-icon
                    >
                    <span class="ma-0"
                      >نام دسته بندی : <span>{{ card.mobile }}</span></span
                    >
                  </div>
                  <div class="mt-3">
                    <v-icon class="font-weight-bold" color="amber darken-1"
                      >mdi-comment-check-outline</v-icon
                    >
                    <span class="ma-0"
                      >وضعیت :
                      <v-chip x-small color="blue white--text" class="py-3">{{
                        card.isActive ? " فعال" : "غیرفعال"
                      }}</v-chip></span
                    >
                  </div>
                  <div class="mt-3">
                    <v-icon class="font-weight-bold" color="amber darken-1"
                      >mdi-person</v-icon
                    >
                    <span class="ma-0"
                      >نام فروشنده :
                      <v-chip
                        x-small
                        color="deep-purple lighten-1 white--text"
                        class="py-3"
                        >{{ card.isHost }}</v-chip
                      ></span
                    >
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#00932a"
                    class="green lighten-4"
                    outline
                    text
                    @click="dialogCard = false"
                    >تایید کردن</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:[`item.isActive`]="{ item }">
          <v-chip color="9FA8DA" class="mr-1 9FA8DA" text-color="white" small>{{
            item.isActive
          }}</v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="9FA8DA"
                class="mr-1 9FA8DA"
                v-bind="attrs"
                v-on="on"
                @click="showInfo(item)"
              >
                mdi-eye-settings
              </v-icon>
            </template>
            <span>مشاهده</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="9FA8DA"
                class="mr-1 9FA8DA"
                @click="getUser(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>ویرایش</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="9FA8DA"
                class="mr-1 9FA8DA"
                @click="deleteItem(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>حذف</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="9FA8DA"
                class="mr-1 9FA8DA"
                @click="ToggleItem(item)"
                v-bind="attrs"
                v-on="on"
                >mdi-rotate-3d-variant</v-icon
              >
            </template>
            <span>تغییر وضعیت</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary"> ریکوردی یافت نشد </v-btn>
        </template>
      </v-data-table>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
import datePicker from "@alireza-ab/vue-persian-datepicker";
import baseURL from "@/axios";
export default {
  components: {
    datePicker,
  },
  data: () => ({
    showLoading: false,
    dialogDelete: false,
    dialogShow: false,
    dialogCard: false,
    selected: [],
    code: null,
    objectName: null,
    categoryName: null,
    objectType: null,
    sellerName: null,
    date: null,
    showStatus: null,
    showCase: null,
    showId: null,
    todatevalue: null,
    fromdatevalue: null,
    showDatepicker: false,
    headers: [
      {
        text: "نام",
        align: "right",
        value: "name",
      },
      { text: "نام خانوادگی", value: "lastName" },
      { text: "کد ملی", value: "mobile" },
      { text: "شماره تلفن", value: "phone", align: "center" },
      { text: "تاریخ ثبت", value: "insertDate", align: "left" },
      //   { text: "تنظیمات", value: "actions", sortable: false, align: "left" },
    ],
    filters: {
      name: [],
      lastName: [],
      mobile: [],
      phone: [],
    },
    card: {
      name: null,
      mobile: null,
      phone: null,
      lastName: null,
    },
    typeId: 0,
    desserts: [],
  }),
  created() {
    this.showLoading = true;
    axios
      .get(`${baseURL}Provider/GetAll`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        this.showLoading = false;
        this.listData1 = response.data.data;
        this.listData1.map((item) => {
          item.insertDate = new Date(item.insertDate).toLocaleDateString(
            "fa-IR"
          );
          this.desserts.push({
            name: item.firstName,
            id: item.id,
            lastName: item.lastName,
            mobile: item.nationalCode,
            phone: item.username,
            isHost: item.providerTitle,
            insertDate: item.registerDate,
          });
        });
      })

      .catch(() => {
        this.showLoading = false;
      });
  },
  computed: {
    filteredDesserts() {
      return this.desserts.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },

  methods: {
    closeDatePicker() {
      this.showDatepicker = false;
    },
    showDate() {
      this.showDatepicker = true;
    },
    async filterList() {
      this.showLoading = true;
      this.date = [];
      if (this.date[1]) {
        this.todatevalue = this.date[1];
        this.fromdatevalue = this.date[0];
      }
      this.desserts.map((item) => {
        if (this.filters.typeTitle == item.typeTitle) {
          this.typeId = item.typeId;
          ////////console.log(item.typeId);
        }
      });
      await axios
        .post(
          `http://apikaraclub.spad-host.ir/api/Agency/GetAll`,
          {
            title: this.filters.name == 0 ? null : this.filters.name,
            email: this.filters.email == 0 ? null : this.filters.email,
            geoDivisionTitle:
              this.filters.geoDivisionTitle == 0
                ? null
                : this.filters.geoDivisionTitle,
            typeId: this.typeId,
            phoneNumber:
              this.filters.mobile.length == 0 ? null : this.filters.mobile,
            fromDate: this.fromdatevalue,
            toDate: this.todatevalue,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          this.showLoading = false;
          this.desserts = [];
          response.data.data.map((item) => {
            this.desserts.push({
              name: item.title,
              id: item.id,
              mobile: item.phone,
              isActive: item.isActive,
              isHost: item.isHost,
              role: item.role,
              email: item.email,
              geoDivisionTitle: item.geoDivisionTitle,
              insertDate: item.insertDate,
              typeTitle: item.typeTitle,
              typeId: item.typeId,
            });
          });
        })
        .catch(() => {
          this.showLoading = false;
        });
    },
    columnValueList(val) {
      return this.desserts.map((d) => d[val]);
    },
    deleteItem(item) {
      this.deleteId = item.id;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.showLoading = true;
      await axios
        .delete(
          `http://apikaraclub.spad-host.ir/api/Agency/Delete?id=${this.deleteId}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          this.showLoading = false;
        })
        .catch(() => {
          this.showLoading = false;
        });
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    ToggleItem(item) {
      this.showId = item.id;
      this.showCase = item;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogShow = true;
    },

    toggleActivation() {
      this.showLoading = true;
      axios
        .post(
          `http://apikaraclub.spad-host.ir/api/Hotel/ChangeActivationStatus?id=${this.showCase.id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          this.showLoading = false;
          this.dialogShow = false;
          this.desserts[this.desserts.indexOf(this.showCase)].isActive =
            !this.desserts[this.desserts.indexOf(this.showCase)].isActive;
        })
        .catch(() => {
          this.showLoading = false;
          this.dialogShow = false;
        });
    },

    showInfo(item) {
      this.card.name = item.name;
      this.card.mobile = item.mobile;
      this.card.email = item.email;
      this.card.geoDivisionTitle = item.geoDivisionTitle;
      this.card.isActive = item.isActive;
      this.card.typeTitle = item.typeTitle;
      this.card.isHost = item.isHost;
      this.card.insertDate = item.insertDate;
      ////////console.log(this.card);
      this.dialogCard = true;
    },

    getUser(item) {
      this.$router.push(`/place/hotels/edit/${item.id}`);
    },
  },
};
</script>

<style>
.pdp .pdp-group {
  display: none;
}
.filter-items .v-input {
  padding: 0 !important;
  margin: 0 !important;
}
.filter-btn {
  background: #001f4b;
  color: #fff;
}
.v-select__slot input,
.v-text-field__slot input {
  font-size: 13px;
  color: #5f5f5f !important;
}
.ff0000--text {
  color: #ff0000 !important;
  background: #ff00002e !important;
  border-radius: 5px;
}
.ffb100--text {
  color: #ffb100 !important;
  background: #ffb1002b;
  border-radius: 5px;
}

.show--text {
  color: #29b6f6 !important;
  background: #29b6f62b;
  border-radius: 5px;
}
.toogle-icon--text {
  color: #512da8 !important;
  background: #522da848;
  border-radius: 5px;
}
.v-application .text-h5 {
  font-family: "iransans", "yekan", "vazir" !important;
}
.loading .v-application--wrap {
  justify-content: center;
  align-items: center;
}
.card-info-content span {
  font-size: 15px;
}
</style>
